<template>
  <v-card>
    <v-card-title class="headline">
      {{ $t("privacy.title") }}
    </v-card-title>
    <v-card-text>
      <div>
        <p>
          {{ $t("privacy.p1") }}
        </p>
        <h2 class="subheading">{{ $t("privacy.general.title") }}</h2>
        <template v-for="section in $t('privacy.general.sections')">
          <h3 class="body-2" :key="section.title">{{ section.title }}</h3>
          <p v-for="item in section.items" :key="item" v-html="item"></p>
        </template>
      </div>
    </v-card-text>
    <v-card-actions v-if="showActions">
      <v-spacer></v-spacer>
      <v-btn
        class="primary"
        flat
        @click="$emit('dataPrivacyStatementModal', false)"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import "suitcss-utils-text";

export default {
  props: {
    showActions: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
/** @define AgDataPrivacyStatement; weak */

/* stylelint-disable */
.matomoInfoTable {
  border-collapse: collapse;
  text-align: center;
  width: 100%;
}
.matomoInfoTable > tbody > tr > th {
  border: 1px solid #000000;
}
.matomoInfoTable > tbody > tr > td {
  border: 1px solid #000000;
}
#firstRow {
  background-color: #a8a8a8;
}
/* stylelint-enable */
</style>
